export const galleryCategories = [
  { id: 'all', label: 'All Projects' },
  { id: 'kitchen', label: 'Kitchen' },
  { id: 'bathroom', label: 'Bathroom' },
  { id: 'exterior', label: 'Exterior' },
  { id: 'roofing', label: 'Roofing' },
  { id: 'other', label: 'Other' },
];

export const allGalleryProjects = [
  {
    id: 1,
    title: 'Full Kitchen Renovation',
    category: 'kitchen',
    type: 'Kitchen Remodel',
    location: 'South Florida',
    duration: '2-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/90a5bae7-3cbe-4eec-a33e-38a5eaacf8f4_IMG_4213.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/57f56af7-5e51-46a3-82ee-71092a960e51_IMG_5043.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/90a5bae7-3cbe-4eec-a33e-38a5eaacf8f4_IMG_4213.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/0e7b13e1-5ef8-4d62-b739-6b795793fc14_IMG_4215.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/57f56af7-5e51-46a3-82ee-71092a960e51_IMG_5043.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/0c527c31-05c1-40b6-9d39-13ac11e9164d_IMG_5044.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/42fc37b7-8ed0-4cc2-8f4a-48b3ce7eded3_IMG_5045.jpeg',
    ],
    description: 'Complete kitchen transformation featuring custom white shaker cabinets, dark stone countertops and backsplash, stainless steel appliances, new luxury vinyl flooring, and modern brushed nickel hardware. The yellow walls and dated layout were replaced with a clean, contemporary design that maximizes storage and workspace.',
    review: null,
  },
  {
    id: 2,
    title: 'Outdoor Shower Installation',
    category: 'exterior',
    type: 'Outdoor Living',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f93eb1c1-e4e8-4642-9e0f-2f8352293322_IMG_5148.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/e7b200a8-349c-4da9-a446-18b1764abab3_IMG_5156.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f93eb1c1-e4e8-4642-9e0f-2f8352293322_IMG_5148.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/e7b200a8-349c-4da9-a446-18b1764abab3_IMG_5156.jpeg',
    ],
    description: 'Custom outdoor shower installation featuring exposed plumbing converted to a beautiful cedar wood paneling enclosure. The natural wood finish complements the poolside patio area while providing privacy and a clean, modern look for the outdoor living space.',
    review: null,
  },
  {
    id: 3,
    title: 'Bathroom Renovation',
    category: 'bathroom',
    type: 'Bathroom Remodel',
    location: 'South Florida',
    duration: '1-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/399b25da-851c-4a83-b974-8a38e16e7ea3_IMG_8627.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/36094d3a-1626-49ba-9c5e-4a702dde65dc_IMG_8738.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/399b25da-851c-4a83-b974-8a38e16e7ea3_IMG_8627.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/b95d6ede-6e6c-4894-bd89-2e9e98e948a2_IMG_8628.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/36094d3a-1626-49ba-9c5e-4a702dde65dc_IMG_8738.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/e1c8f654-c176-4d56-97b2-b46ed87fd6d2_IMG_8739.jpeg',
    ],
    description: 'Complete bathroom renovation featuring removal of dated yellow tile, new gray porcelain tile with mosaic glass accent strips, upgraded tub-to-shower conversion, new dark espresso vanity with quartz countertop, modern brushed nickel fixtures, and elegant LED lighting with upgraded mirror.',
    review: null,
  },
  {
    id: 4,
    title: 'Kitchen Island Conversion',
    category: 'kitchen',
    type: 'Kitchen Remodel',
    location: 'South Florida',
    duration: '3-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/986aeed2-97f5-498e-bbb4-9b04ce64830e_IMG_8614.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/2b675ecc-0d3a-4424-8979-525b1570c546_IMG_9209.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/986aeed2-97f5-498e-bbb4-9b04ce64830e_IMG_8614.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/68d04d90-3803-41e1-bf1e-c7c07454d56c_IMG_8615.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/2b675ecc-0d3a-4424-8979-525b1570c546_IMG_9209.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/64013355-1bf9-406d-aa01-e11d8aaef26f_IMG_9210.jpeg',
    ],
    description: 'Kitchen transformation removing a dark cabinet wall and converting it into an open granite-top kitchen island peninsula. This renovation opened the kitchen to the dining area, creating better flow and adding counter seating space while maintaining the existing dark cabinetry style.',
    review: null,
  },
  {
    id: 5,
    title: 'Kitchen Cabinet & Backsplash Upgrade',
    category: 'kitchen',
    type: 'Kitchen Remodel',
    location: 'South Florida',
    duration: '2-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/fdf3d2c9-23d9-4572-9dbb-e9aff8d22f0c_IMG_2430.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/3b66f65e-dabc-41b0-9164-1d5ba2b195e5_IMG_1932.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/fdf3d2c9-23d9-4572-9dbb-e9aff8d22f0c_IMG_2430.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/13416403-ae12-4be4-a81b-8823021fbeef_IMG_2431.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/3b66f65e-dabc-41b0-9164-1d5ba2b195e5_IMG_1932.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/5a9c28cd-bbbf-432c-9671-37db656c8b64_IMG_1935.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a49b6411-ed6c-4fa1-8e8a-19fc7412a74a_IMG_1936.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/4f79f441-a0b1-430b-8724-c5dd1522fc7c_IMG_1937.jpeg',
    ],
    description: 'Kitchen transformation replacing dated white cabinetry with rich dark espresso wood cabinets and installing a stunning hexagonal stone mosaic backsplash. The renovation includes new white quartz countertops, brushed nickel hardware, and a complete upgrade from the old white appliance package to a modern integrated look.',
    review: null,
  },
  {
    id: 6,
    title: 'Minor Roof Repairs',
    category: 'roofing',
    type: 'Roof Repair',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/52d448be-8b75-4722-ab2c-f0828b16abee_IMG_8876.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/4ad797ee-6d6d-44bf-bf78-30eb7b67b4ee_IMG_8882.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/52d448be-8b75-4722-ab2c-f0828b16abee_IMG_8876.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/5ee37537-4baf-468a-93c2-1e4d47dd4365_IMG_8878.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/c8dcc898-dcc2-4c5e-95bd-aa3cf8c2db07_IMG_8877.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/4ad797ee-6d6d-44bf-bf78-30eb7b67b4ee_IMG_8882.jpeg',
    ],
    description: 'Professional roof repair addressing a damaged section with exposed rafters and debris. The repair involved removing the damaged shingles, installing new plywood sheathing, and replacing the shingles with matching asphalt composite shingles for a seamless finish.',
    review: null,
  },
  {
    id: 7,
    title: 'Combo Washer Dryer Installation',
    category: 'kitchen',
    type: 'Kitchen Upgrade',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/110c94c4-b2b2-42b3-840b-775f4690ede7_edited_kitchen_reflection_removed_image_2-1.png',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/9430921d-2011-4837-ae35-cc27b3c06a0f_wide_interior_kitchen_scene_viewed_at_a_slight_ang_1_batch_1-1.png',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/110c94c4-b2b2-42b3-840b-775f4690ede7_edited_kitchen_reflection_removed_image_2-1.png',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/9430921d-2011-4837-ae35-cc27b3c06a0f_wide_interior_kitchen_scene_viewed_at_a_slight_ang_1_batch_1-1.png',
    ],
    description: 'Smart kitchen upgrade converting a lower cabinet into a space for a compact combo washer dryer unit. The existing oak cabinetry was modified to accommodate the new Midea laundry machine, with the original cabinet removed and plumbing connections updated for the washer. The result adds laundry functionality without sacrificing the kitchen layout or aesthetic.',
    review: null,
  },
  {
    id: 8,
    title: 'Floating Shelves Installation',
    category: 'other',
    type: 'Custom Shelving',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f2936331-0961-4bbb-a72a-e0a2ef95ff45_IMG_1753.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f2936331-0961-4bbb-a72a-e0a2ef95ff45_IMG_1753.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f2936331-0961-4bbb-a72a-e0a2ef95ff45_IMG_1753.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f2936331-0961-4bbb-a72a-e0a2ef95ff45_IMG_1753.jpeg',
    ],
    description: 'Custom floating shelf installation featuring three sleek white minimalist shelves mounted on a neutral wall. Perfect for displaying decor, books, or small items in a clean modern aesthetic. The brackets are hidden for a true floating look with no visible hardware.',
    review: null,
  },
  {
    id: 9,
    title: 'Custom Wine Rack & Shelves',
    category: 'other',
    type: 'Custom Shelving',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/fecb7bdc-e031-494e-9421-9752912262e5_IMG_6920.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/fecb7bdc-e031-494e-9421-9752912262e5_IMG_6920.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/fecb7bdc-e031-494e-9421-9752912262e5_IMG_6920.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/fecb7bdc-e031-494e-9421-9752912262e5_IMG_6920.jpeg',
    ],
    description: 'Custom rustic wood floating shelf and stem glass rack installation. The top shelf features a built-in glass holder for hanging wine glasses, with a lower shelf designed for wine bottle storage. The dark stained wood finish adds a warm farmhouse-style touch to the space.',
    review: null,
  },
  {
    id: 10,
    title: 'Kitchen Cabinet & Backsplash Renovation',
    category: 'kitchen',
    type: 'Kitchen Remodel',
    location: 'South Florida',
    duration: '2-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a0748533-836e-4a0d-a758-d5b911289905_IMG_2748.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a0748533-836e-4a0d-a758-d5b911289905_IMG_2748.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a0748533-836e-4a0d-a758-d5b911289905_IMG_2748.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f8afaccc-ee7c-424e-ae35-bf1074beef66_IMG_2749.jpeg',
    ],
    description: 'Complete kitchen renovation featuring custom white shaker cabinets with brushed nickel hardware, granite countertops with marble-pattern backsplash, and a modern open layout with a breakfast bar peninsula. Under-cabinet lighting and stainless steel appliances complete the updated look.',
    review: null,
  },
  {
    id: 11,
    title: 'Laundry Room Cabinet Installation',
    category: 'other',
    type: 'Custom Cabinetry',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/2ff68ff8-f025-4454-9a4a-32c2a7800bb9_IMG_2750.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/2ff68ff8-f025-4454-9a4a-32c2a7800bb9_IMG_2750.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/2ff68ff8-f025-4454-9a4a-32c2a7800bb9_IMG_2750.jpeg',
    ],
    description: 'Custom white shaker cabinet installation above washer and dryer units. Four-door wall-mounted cabinet provides ample storage for laundry supplies and linens while maintaining a clean, organized appearance in the utility space.',
    review: null,
  },
  {
    id: 12,
    title: 'Small Bathroom Vanity Upgrade',
    category: 'bathroom',
    type: 'Bathroom Upgrade',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a08c212e-1663-4c73-8f93-16060d401ba6_IMG_2751.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a08c212e-1663-4c73-8f93-16060d401ba6_IMG_2751.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a08c212e-1663-4c73-8f93-16060d401ba6_IMG_2751.jpeg',
    ],
    description: 'Compact bathroom vanity installation featuring a white shaker-style cabinet with brushed nickel hardware, granite countertop, and an undermount sink. The corner-fit design maximizes the small bathroom space while adding a clean modern look.',
    review: null,
  },
  {
    id: 13,
    title: 'Stone Veneer Accent Wall & Flooring',
    category: 'other',
    type: 'Interior Renovation',
    location: 'South Florida',
    duration: '1-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a17fbdae-c585-489e-8826-658a88b2c256_IMG_6857.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a17fbdae-c585-489e-8826-658a88b2c256_IMG_6857.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/b725b1f0-519d-4243-9ba4-bec503aadc16_IMG_6856.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/a17fbdae-c585-489e-8826-658a88b2c256_IMG_6857.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/cfd1f6ba-7961-4d36-80d3-e14d3f4b34c3_IMG_6859.jpeg',
    ],
    description: 'Interior renovation featuring a stunning stacked stone veneer accent wall with warm earth tones and a full luxury vinyl plank flooring installation throughout the room. The natural stone texture creates a bold focal point, complemented by the modern gray-toned wood-look flooring.',
    review: null,
  },
  {
    id: 14,
    title: 'Luxury Double Vanity Bathroom',
    category: 'bathroom',
    type: 'Bathroom Remodel',
    location: 'South Florida',
    duration: '2-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/4700aa6c-d0b9-4d45-b7eb-f72f1eb9b118_IMG_8190.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/4700aa6c-d0b9-4d45-b7eb-f72f1eb9b118_IMG_8190.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/4700aa6c-d0b9-4d45-b7eb-f72f1eb9b118_IMG_8190.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/52eb3742-1ad1-4be7-b4bf-28a56c0edb54_IMG_8192.jpeg',
    ],
    description: 'Custom luxury double vanity bathroom featuring a sleek gray quartz countertop with integrated dual sinks, modern brushed nickel faucets, and a slatted wood-front cabinet with satin finish. Wall-mounted mirrors with brushed nickel frames and warm sconce lighting complete the spa-like atmosphere.',
    review: null,
  },
  {
    id: 15,
    title: 'Wooden Deck Installation',
    category: 'exterior',
    type: 'Deck Build',
    location: 'South Florida',
    duration: '2-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/095df959-6d75-4e1f-abe8-e7970876e350_IMG_0164.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/095df959-6d75-4e1f-abe8-e7970876e350_IMG_0164.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/095df959-6d75-4e1f-abe8-e7970876e350_IMG_0164.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/7525ae13-00f2-4b03-9690-18adb2b94c24_IMG_0165.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/7fb9bf93-3004-4d50-b5ae-e5a295b289db_IMG_0166.jpeg',
    ],
    description: 'Custom pressure-treated wood deck installation with a raised platform design, sturdy perimeter framing, and secure mounting. The deck provides a clean outdoor living space adjacent to a sliding patio door, with a white picket fence enclosure for added privacy and safety.',
    review: null,
  },
  {
    id: 16,
    title: 'Exterior Fascia Soffit; Overhang Repair',
    category: 'exterior',
    type: 'Exterior Repair',
    location: 'South Florida',
    duration: '2-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/24bd998f-a3e2-4e17-a54f-27e8936ae998_71433640993__A744FC26-03F5-477F-A126-5A1F7E657B21.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/24bd998f-a3e2-4e17-a54f-27e8936ae998_71433640993__A744FC26-03F5-477F-A126-5A1F7E657B21.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/24bd998f-a3e2-4e17-a54f-27e8936ae998_71433640993__A744FC26-03F5-477F-A126-5A1F7E657B21.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/85a5af96-518f-476a-9562-bc543398e3ff_71433642688__6A02B90F-8B0E-446A-915A-0AF85D03A5E6.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/18ec54d0-3c28-4ce4-a0ac-30f31e71a925_71433643748__519A9CB5-1248-4825-BDF7-EF15688FF48F.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/ee1aaad4-6027-4d2f-901e-9a1b0ad5c0c1_71433645192__74175690-9C2A-4438-B0D9-B005A13BA762.jpeg',
    ],
    description: 'Professional exterior fascia board and roof overhang repair and repainting work. The project included addressing damaged and deteriorated fascia trim, fresh paint application, and restoring the exterior trim to a clean, weather-resistant finish.',
    review: null,
  },
  {
    id: 17,
    title: 'Bedroom Renovation Flooring',
    category: 'other',
    type: 'Interior Renovation',
    location: 'South Florida',
    duration: '1-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f85ae98b-2ecc-4bf0-b8e2-227d61d46a55_IMG_7993.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f85ae98b-2ecc-4bf0-b8e2-227d61d46a55_IMG_7993.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f85ae98b-2ecc-4bf0-b8e2-227d61d46a55_IMG_7993.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/e2638ca2-0cff-45cc-92c6-9c74427455be_IMG_7994.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/711c9d3e-1664-4e7d-86c5-97b7bef6b98c_IMG_7995.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/d595a2b5-f998-4812-a556-e69e7cbf6d90_IMG_7996.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/9d1a760b-91e5-4efe-82b4-9dc1a1d0eb1d_IMG_7997.jpeg',
    ],
    description: 'Complete bedroom renovation featuring new luxury vinyl plank flooring with warm gray tones, custom white board-and-batten wainscoting, and crisp white baseboard trim. The room includes fresh paint in a warm neutral palette, modern white-framed windows, and a clean closet with white shelving.',
    review: null,
  },
  {
    id: 18,
    title: 'Bathroom Remodel Gold & Marble',
    category: 'bathroom',
    type: 'Bathroom Remodel',
    location: 'South Florida',
    duration: '2-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/8bfed3d1-888b-42c1-b436-22545e870924_IMG_8487.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/9a0a35bc-feff-4963-8583-b13b5733093d_IMG_0818.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/8bfed3d1-888b-42c1-b436-22545e870924_IMG_8487.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/08b71f29-ff66-4c45-af64-b3d5d3108e7c_IMG_8488.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/9a0a35bc-feff-4963-8583-b13b5733093d_IMG_0818.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/f4a22ca6-689a-4bae-8107-ef56360c8f2a_IMG_0832.jpeg',
    ],
    description: 'Complete bathroom transformation featuring removal of dated pink tile and a pink tub, replacing them with stunning marble-pattern porcelain tile in warm gold and cream tones, and a fresh white tub. The renovation includes a custom wood vanity with a white marble countertop and undermount sink, brass gold fixtures and shower hardware, a modern frameless glass shower door, and an upgraded large mirror with gold-accented vanity lighting. The old oak medicine cabinet and beige fixtures were replaced with a clean, luxurious modern aesthetic.',
    review: null,
  },
  {
    id: 19,
    title: 'Kitchen & Living Room Renovation',
    category: 'kitchen',
    type: 'Full Home Renovation',
    location: 'South Florida',
    duration: '3-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/d8e4e1a1-18b3-4790-b55f-a324fde98caf_IMG_1771.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/d2454e2d-3940-426d-8489-26f1320d39d8_IMG_2144.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/d8e4e1a1-18b3-4790-b55f-a324fde98caf_IMG_1771.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/bf2e5e76-1ebf-4123-9c0d-35ffc6524a61_IMG_1774.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/d2454e2d-3940-426d-8489-26f1320d39d8_IMG_2144.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/6babf051-385a-4126-a3d9-1bd35061707d_IMG_2147.jpeg',
    ],
    description: 'Complete kitchen and living room renovation transforming dated oak cabinetry and dark two-tone tile into a bright modern open-concept space. The kitchen features new white shaker cabinets with brushed nickel hardware, white marble countertops and a green marble backsplash, plus new light luxury vinyl plank flooring. The living room was updated with matching wood flooring, fresh gray walls, white crown molding, and removal of the old mirrored wall panels. French doors to the pool area were preserved and enhanced by the clean modern aesthetic.',
    review: null,
  },
  {
    id: 20,
    title: 'Kitchen Cabinet & Marble Backsplash Upgrade',
    category: 'kitchen',
    type: 'Kitchen Remodel',
    location: 'South Florida',
    duration: '2-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/5e4dadb1-8d60-44dc-80b0-ff9718885bd7_IMG_2341.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/e01e6be0-b0cb-4324-a965-439debcea571_IMG_2816.jpeg',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/5e4dadb1-8d60-44dc-80b0-ff9718885bd7_IMG_2341.jpeg',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/e01e6be0-b0cb-4324-a965-439debcea571_IMG_2816.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/5973370c-0eb9-4e97-83ee-62bfa5b0374a_IMG_2817.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/3eba66f1-ed6e-49dc-9ccd-bace5cd2e050_IMG_2818.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/382a484d-e0bf-4427-9bba-16a1ccc39cf2_IMG_2819.jpeg',
    ],
    description: 'Kitchen transformation replacing dated white cabinets with sleek modern flat-panel white cabinetry and installing a stunning gray marble backsplash and countertop that extends the full height of the wall. The renovation includes a new stainless steel over-the-range microwave, modern stainless steel stove with smooth cooktop, and a large stainless steel undermount sink with a contemporary brushed nickel faucet. The old open shelving and small mosaic tile were replaced with a clean, seamless marble look.',
    review: null,
  },
  {
    id: 21,
    title: 'Laundry Room Cabinet & Countertop',
    category: 'other',
    type: 'Custom Cabinetry',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/0159fc49-c4a4-4e99-8b1a-9fb271e57508_IMG_9063.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/0159fc49-c4a4-4e99-8b1a-9fb271e57508_IMG_9063.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/0159fc49-c4a4-4e99-8b1a-9fb271e57508_IMG_9063.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/023fb4a2-e5e9-4694-8714-ebf8ff0f9b9b_IMG_9064.jpeg',
    ],
    description: 'Custom white shaker cabinet and countertop installation in a compact laundry room. The design includes upper wall cabinets and a lower base cabinet with a solid white countertop, providing ample storage and a folding surface next to the stacked washer and dryer units. Black hardware accents complement the modern appliances.',
    review: null,
  },
  {
    id: 22,
    title: 'Bathroom Vanity & Marble Countertop',
    category: 'bathroom',
    type: 'Bathroom Upgrade',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/920a6908-5cef-4fb4-a6fc-053eff5961aa_71165748947__19EA2305-74EB-49E1-A02F-7CF0F9DB3A24.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/920a6908-5cef-4fb4-a6fc-053eff5961aa_71165748947__19EA2305-74EB-49E1-A02F-7CF0F9DB3A24.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/920a6908-5cef-4fb4-a6fc-053eff5961aa_71165748947__19EA2305-74EB-49E1-A02F-7CF0F9DB3A24.jpeg',
    ],
    description: 'Custom bathroom vanity installation featuring a gray painted cabinet with detailed drawer fronts and a white marble countertop with integrated backsplash. The undermount sink is paired with a modern brushed nickel faucet. The project is part of an ongoing bathroom refresh with old floral wallpaper being removed.',
    review: null,
  },
  {
    id: 23,
    title: 'Kitchen Cabinet & Granite Installation',
    category: 'kitchen',
    type: 'Kitchen Remodel',
    location: 'South Florida',
    duration: '2-Week Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/3806eb64-6063-4c06-b61d-1aabb94d2f0b_IMG_7425.jpg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/3806eb64-6063-4c06-b61d-1aabb94d2f0b_IMG_7425.jpg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/3806eb64-6063-4c06-b61d-1aabb94d2f0b_IMG_7425.jpg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/e5820a53-3117-4ef4-ba77-f73fbac396fc_IMG_8717.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/4e5a0797-c903-4999-a79a-3d282fcaf5a9_IMG_8718.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/458a702e-cf65-4f4b-a906-5493924e8799_IMG_8719.jpeg',
    ],
    description: 'Complete kitchen renovation featuring custom white shaker cabinets with brushed nickel hardware, black granite countertops, and a modern white glass tile backsplash. The kitchen includes stainless steel appliances including a French door refrigerator, over-the-range microwave, and smooth-top electric range. Glass-front upper cabinets add display space, and the U-shaped layout maximizes counter and storage space.',
    review: null,
  },
  {
    id: 24,
    title: 'Exterior Patio & Door Installation',
    category: 'exterior',
    type: 'Exterior Upgrade',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/bac1a942-4b3e-4f5c-a8fe-60870072ec6f_IMG_6112.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/bac1a942-4b3e-4f5c-a8fe-60870072ec6f_IMG_6112.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/bac1a942-4b3e-4f5c-a8fe-60870072ec6f_IMG_6112.jpeg',
    ],
    description: 'Exterior patio and entry door upgrade featuring a new white six-panel entry door with modern brushed nickel hardware, installed in a covered patio area with light green exterior walls. The patio overlooks a serene canal with lush greenery, and the updated door provides a clean, modern look for the home entry.',
    review: null,
  },
  {
    id: 25,
    title: 'Dark Brown Horizontal Slat Fence',
    category: 'exterior',
    type: 'Fence Installation',
    location: 'South Florida',
    duration: '2-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/8fa6ade0-3d19-4ec0-9725-078370e29abd_70369231506__64CE8DE6-7AF0-47B8-9CA6-0EDBD79059F0.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/8fa6ade0-3d19-4ec0-9725-078370e29abd_70369231506__64CE8DE6-7AF0-47B8-9CA6-0EDBD79059F0.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/8fa6ade0-3d19-4ec0-9725-078370e29abd_70369231506__64CE8DE6-7AF0-47B8-9CA6-0EDBD79059F0.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/100b4802-bc94-4ff5-b9f3-7e47286625af_IMG_7176.jpeg',
    ],
    description: 'Modern horizontal slat fence installation with dark brown stained wood and black metal posts. Surrounded by tropical landscaping with palm trees and vibrant foliage.',
    review: null,
  },
  {
    id: 26,
    title: 'Natural Wood Picket Fence & Gate',
    category: 'exterior',
    type: 'Fence Installation',
    location: 'South Florida',
    duration: '2-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/c03a4c35-c874-4463-86b9-0b0a9d1a4684_IMG_3292.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/c03a4c35-c874-4463-86b9-0b0a9d1a4684_IMG_3292.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/c03a4c35-c874-4463-86b9-0b0a9d1a4684_IMG_3292.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/58ff8982-e796-4011-956b-24c0c8a09937_IMG_3303.jpeg',
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/608fefe5-1262-4765-b7d6-6b106b7cec83_IMG_3304.jpeg',
    ],
    description: 'Complete natural wood picket fence installation with a custom gate. Features pressure-treated lumber with scalloped top design, set in a tropical backyard with lush palm trees and vegetation.',
    review: null,
  },
  {
    id: 27,
    title: 'Dark Brown Fence Gate with Brick Column',
    category: 'exterior',
    type: 'Fence Installation',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/99389ec2-135f-4d37-bdf4-15a13adb2531_IMG_9223.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/99389ec2-135f-4d37-bdf4-15a13adb2531_IMG_9223.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/99389ec2-135f-4d37-bdf4-15a13adb2531_IMG_9223.jpeg',
    ],
    description: 'Custom dark brown vertical board fence gate featuring a white brick column with a hose bib and electrical outlet. Finished with a decorative Smile You Are On Camera sign.',
    review: null,
  },
  {
    id: 28,
    title: 'Natural Wood Gate with Keypad Lock',
    category: 'exterior',
    type: 'Fence Installation',
    location: 'South Florida',
    duration: '1-Day Project',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/fa8f857e-6d5e-47ed-a036-8ac684c3cd36_IMG_9399.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/fa8f857e-6d5e-47ed-a036-8ac684c3cd36_IMG_9399.jpeg',
    beforeImages: [],
    afterImages: [],
    galleryImages: [
      'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/fa8f857e-6d5e-47ed-a036-8ac684c3cd36_IMG_9399.jpeg',
    ],
    description: 'New natural wood picket fence gate with a modern keypad entry lock system. Installed alongside a stucco house with decorative wrought iron wall art.',
    review: null,
  },
];